import { lazy } from 'react';
import { DeferAsyncComponentLoading } from 'unified-navigation-ui/components/DeferAsyncComponentLoading';
import { jsx as _jsx } from "react/jsx-runtime";
const NOTIFICATIONS_COMPONENT_LOAD_TIMEOUT = 0;
const AsyncSetupNotifications = /*#__PURE__*/lazy(() => import('./SetupNotifications').then(({
  SetupNotifications
}) => ({
  default: SetupNotifications
})));
export const SetupNotifications = () => /*#__PURE__*/_jsx(DeferAsyncComponentLoading, {
  fallback: null,
  loadTimeout: NOTIFICATIONS_COMPONENT_LOAD_TIMEOUT,
  children: /*#__PURE__*/_jsx(AsyncSetupNotifications, {})
});